import { Link } from "react-router-dom";
import { MapPin, Clock, Mail, Phone, Star, Heart } from "lucide-react";
import { studioInfo } from "../data/mock";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img 
                src="/logo.png" 
                alt="GetFit Fitness Studio" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-sm mb-4">
              Where fitness meets community. Achieve your goals with personalized training and
              unwavering support.
            </p>
            <div className="flex items-center gap-1 text-[#9FFF00]">
              <Star className="w-5 h-5 fill-current" />
              <span className="font-bold text-lg">{studioInfo.rating}</span>
              <span className="text-sm text-gray-400 ml-1">Rating</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-[#9FFF00] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-[#9FFF00] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-[#9FFF00] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-sm hover:text-[#9FFF00] transition-colors">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-[#9FFF00] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-white mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-[#9FFF00] flex-shrink-0 mt-0.5" />
                <span className="text-sm">{studioInfo.address}</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-5 h-5 text-[#9FFF00] flex-shrink-0 mt-0.5" />
                <span className="text-sm">{studioInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-5 h-5 text-[#9FFF00] flex-shrink-0 mt-0.5" />
                <span className="text-sm">{studioInfo.email}</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="font-bold text-white mb-4">Hours</h3>
            <div className="flex items-start gap-2 mb-4">
              <Clock className="w-5 h-5 text-[#9FFF00] flex-shrink-0 mt-0.5" />
              <div className="text-sm">
                <p className="mb-1 font-semibold">Monday - Friday</p>
                <p className="text-gray-400">05:00 PM - 7:00 PM</p>
                <p className="text-gray-400 mt-2">Closed: Saturday and Sunday</p>
              </div>
            </div>
            <div className="flex items-center gap-2 mt-4 p-3 bg-gray-800 rounded-lg">
              <Heart className="w-5 h-5 text-[#9FFF00]" />
              <span className="text-sm font-medium text-white">All Welcome</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2024 GetFit Fitness Studio. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="#" className="text-sm text-gray-400 hover:text-[#9FFF00] transition-colors">
                Privacy Policy
              </Link>
              <Link to="#" className="text-sm text-gray-400 hover:text-[#9FFF00] transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
